<li><span>{{ getCurrentValue }},&nbsp;</span><span v-translate="{ text: getRequiredText }"></span><span>{{ last ? '' : ',' }}</span></li>